module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-xl-3 bg-dark vh-100"
  }, [_c('div', {
    staticClass: "py-3"
  }, [_c('router-link', {
    staticClass: "btn btn-outline-primary btn-block",
    attrs: {
      "to": {
        name: 'people-create'
      }
    }
  }, [_vm._v("Add person")])], 1), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('router-link', {
      key: "item.id",
      staticClass: "row py-2",
      attrs: {
        "to": {
          name: 'people-details',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "col-3 col-md-4"
    }, [_c('img', {
      staticClass: "img-fluid rounded-circle bg-faded img-thumbnail",
      attrs: {
        "src": item.image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-9 col-md-8 text-white"
    }, [_vm._v("\n                " + _vm._s(item.name) + "\n                "), _c('div', {
      staticClass: "text-muted"
    }, [_vm._v("\n                    " + _vm._s(item.function) + "\n                ")])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xl-9 vh-100"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af095058"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/people/views/People.vue
// module id = 112
// module chunks = 1